import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=bbbd73f0&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=js"
export * from "./Pay.vue?vue&type=script&lang=js"
import style0 from "./Pay.vue?vue&type=style&index=0&id=bbbd73f0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbd73f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbbd73f0')) {
      api.createRecord('bbbd73f0', component.options)
    } else {
      api.reload('bbbd73f0', component.options)
    }
    module.hot.accept("./Pay.vue?vue&type=template&id=bbbd73f0&scoped=true", function () {
      api.rerender('bbbd73f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/treatment/Pay.vue"
export default component.exports